import React from 'react';
import {
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import TuneIcon from '@mui/icons-material/Tune';
import CalculateIcon from '@mui/icons-material/Calculate';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type Props = {
  scenario: string;
  activeStep: string;
  loading?: boolean;
  onReset: () => void;
  onOpenImport: () => void;
  onRunSensitivity: () => void;
  onApplyScenario: () => void;
};

class BieSimulatorFlowBar extends React.PureComponent<Props> {
  render() {
    const p = this.props;

    const steps = [
      ['SETUP', 'Setup'],
      ['INPUTS', 'Inputs'],
      ['MIXER', 'Mixer'],
      ['RESULTS', 'Results'],
      ['APPLY', 'Apply'],
    ];

    return (
      <Paper elevation={1} sx={{ p: 1.5, mb: 2 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
        >
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
              Simulation Flow
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Current scenario: {p.scenario || '-'}
            </Typography>
          </Box>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            {steps.map(([code, label]) => (
              <Chip
                key={code}
                label={label}
                color={p.activeStep === code ? 'primary' : 'default'}
                variant={p.activeStep === code ? 'filled' : 'outlined'}
                size="small"
              />
            ))}
          </Stack>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Button size="small" variant="outlined" startIcon={<RestartAltIcon />} onClick={p.onReset} disabled={p.loading}>
              Reset
            </Button>
            <Button size="small" variant="outlined" startIcon={<FolderOpenIcon />} onClick={p.onOpenImport} disabled={p.loading}>
              Import
            </Button>
            <Button size="small" variant="outlined" startIcon={<TuneIcon />} onClick={p.onRunSensitivity} disabled={p.loading}>
              Sensitivity
            </Button>
            <Button size="small" variant="contained" startIcon={<CheckCircleIcon />} onClick={p.onApplyScenario} disabled={p.loading}>
              Apply
            </Button>
          </Stack>
        </Stack>
      </Paper>
    );
  }
}

export default BieSimulatorFlowBar;
